<template>
  <div
    v-if="needs"
    class="flex items-center justify-between gap-3 bg-amber-50 border-b border-amber-300 px-4 py-2 text-sm text-amber-800"
  >
    <div class="whitespace-pre-line leading-snug">{{ MESSAGE }}</div>
    <router-link to="/admin/aca-info" class="btn btn-xs btn-warning text-white shrink-0">내정보로 이동</router-link>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { lmsApi } from "../utils/api";

// 안내 문구
const MESSAGE = `🔔 [필수] 사업자등록을 완료해주세요
현재 사업자등록증이 등록되지 않았습니다.
교재비 계산서 발행을 위해 사업자등록이 필요합니다.`;

const needs = ref(false);
const route = useRoute();

async function check() {
  // 원장(학원) 계정 로그인 상태에서만 확인
  if (!localStorage.getItem("token") || localStorage.getItem("accountType") !== "academy") {
    needs.value = false;
    return;
  }
  try {
    const res = await lmsApi.get<any>("/api/admin/aca-info/biz-status");
    needs.value = !!res?.needs;
  } catch (e) {
    console.error("사업자정보 상태 확인 실패:", e);
    needs.value = false;
  }
}

onMounted(check);
// 페이지 이동 시 재확인 → 내정보에서 저장 후 이동하면 배너 자동 해제
watch(() => route.path, check);
</script>
